import { Column } from '@silevis/reactgrid';

export const bankHolidayTabColumns: Column[] = [
  { columnId: 'date', width: 200 },
  { columnId: 'name', width: 200 },
  { columnId: 'description', width: 200 },
  { columnId: 'isPeriodic', width: 100 },
  { columnId: 'delete', width: 100 },
];
